/* --------------------------------------- 상수 선언부 --------------------------------------- */
const NETWORKLINK = {
    "local":{
        imgLink : "https://op-wstatic.ncsoft.com/promo/lineage/event/2022/220209_signaturecoupon/img/items/",
        auth : "http://op.go.plaync.com/account/checkrealname"
    },
    "op":{
        imgLink : "https://op-wstatic.ncsoft.com/promo/lineage/event/2022/220209_signaturecoupon/img/items/",
        auth : "http://op.go.plaync.com/account/checkrealname"
    },
    "rc":{
        imgLink : "https://rc-wstatic.plaync.co.kr/promo/lineage/event/2022/220209_signaturecoupon/img/items/",
        auth : "http://rc.go.plaync.com/account/checkrealname"
    },
    "live":{
        imgLink : "https://wstatic-cdn.plaync.com/promo/lineage/event/2022/220209_signaturecoupon/img/items/",
        auth : "http://go.plaync.com/account/checkrealname"
    },
};
const itemListElement = document.querySelector('#restore-itemList');
const checkElement = document.querySelector('#stamp-container');
const restoreBtn = document.querySelector('#restoreBtn');
const rewardBtn = document.querySelector('#pointRewardBtn');
export const stamp_list = {
    stamp1 : document.querySelector('#stamp-1'),
    stamp2 : document.querySelector('#stamp-2'),
    stamp3 : document.querySelector('#stamp-3'),
    stamp4 : document.querySelector('#stamp-4')
}

/* --------------------------------------- 프로모킷 선언부 --------------------------------------- */
/* 탭 */
let restore_tab = promokit.tab({
    el: '#restore-itemList',
    text: {
        0: '무기',
        1: '방어구',
        2: '액세서리',
        3: '룸티스',
        4: '스냅퍼',
        5: '팬던트',
        6: '휘장',
        7: '문장',
    },
});

/* 셀렉트 박스 */
let server_select = promokit.select({
    el: '#restore-server',
    placeholder: '서버 선택',
    disabled: true
});

let char_select = promokit.select({
    el: '#restore-char',
    placeholder: '캐릭터 선택',
    disabled: true
});

/* 쿠폰함 */
document.getElementById('pointCouponBtn').addEventListener('click',function(e){
    e.preventDefault();
    promokit.coupon();
});

/* 레이어 */
promokit.layer({
    el: '#layer-notice',
    buttons: '#noticeBtn'
});

let layer_restore = promokit.layer({
    el: '#layer-restore',
});

let layer_restored = promokit.layer({
    el: '#layer-restored',
});


/* --------------------------------------- 콜백함수 선언부 --------------------------------------- */
/* 셀렉트 박스 초기화 콜백함수 */
let init_select = (selectBox) => {
    selectBox.update({
        disabled: true,
        options:[]
    });
}

/* 셀렉트 박스 변경 콜백 함수 */
let update_select = (selectBox, arr) => {
    let options = arr.reduce((pre,ele) => {
        if(selectBox === char_select) pre.push({label: ele.name, value : {id : ele.id, class : ele.className}});
        else pre.push({label: ele.serverName, value : ele.serverId});
        return pre;
    },[]);
    selectBox.update({
        disabled: false,
        options: options
    });
}

/* 클릭 시 로그인 이벤트 리스너 등록 콜백 함수 */
let goLoginEvent = (element, url) => {
    element.addEventListener('click',function(e){
        promokit.login(url);
    });
}

/* 버튼 상태 변경 콜백 함수 */
let buttonState = (tab_index) => {
    let missionCount = dataAdapter.getMissionsCount();
    let userData = dataAdapter.getAccountObj();
    let itemData = dataAdapter.getOriginItemList();
    let button_state_restore;
    let button_state_reward;

    //class 초기화 처리
    restoreBtn.classList.remove('disabled', 'complete');
    rewardBtn.classList.remove('disabled');

    // 버튼 케이스별 클래스 정의
    if(itemData[tab_index].itemList.length == 0){ //복구할 아이템이 없음.
        button_state_restore = 'disabled';
    }
    if(missionCount == 0){ //미션 수행 0회
        button_state_restore = 'disabled';
        !(userData.banAccount || userData.gameBanAccount || (!userData.realName)) && (button_state_reward = 'disabled');
    }
    if(itemData[tab_index].restore.state == 1) { //아이템 복구 완료
        button_state_restore = 'complete';
        button_state_reward = 'disabled';
    }
    else if(itemData[tab_index].restore.state == 2) { //쿠폰 받기 완료
        button_state_restore = 'disabled';
        button_state_reward = 'disabled';
    }
    if(!userData.realName) { // 실명 인증
        button_state_restore = 'disabled';
    }
    if(userData.banAccount || userData.gameBanAccount) { //제재 계정
        button_state_restore =  'disabled';
    }
    if(userData.promotionTimeOver) { // 이벤트 기간 종료
        button_state_restore = 'disabled';
        button_state_reward = 'disabled';
    }

    //케이스 해당 사항이 있는 경우 버튼 상태값 클래스 추가
    button_state_restore && restoreBtn.classList.add(button_state_restore);
    button_state_reward && rewardBtn.classList.add(button_state_reward);
}

/* 출석 체크 스탬프 콜백 함수 */
let checkStamp = () => {
    let userData = dataAdapter.getAccountObj();
    let missionCheck = dataAdapter.getMissionsCount();
    let tab_class_name;
    let elementString = "";

    // 이벤트 비정상 케이스 클래스 정의
    if(userData.banAccount || userData.gameBanAccount) tab_class_name = 'p-sec2__stamp-case--banned';
    if(userData.promotionTimeOver) tab_class_name = 'p-sec2__stamp-case--end';
    if(!userData.realName) tab_class_name = 'p-sec2__stamp-case--realname';

    if(tab_class_name !== undefined) { // 이벤트 비정상 케이스
        elementString = `<div class="p-sec2__stamp-case ${tab_class_name}">`;
        if(!userData.realName)elementString += `<button type="button" class="p-btn p-btn__realname">실명인증</button>`;
        elementString += `</div>`;
        document.querySelector("#stamp-container").innerHTML = elementString ;
    } else { //이벤트 정상 케이스
        for(let cnt = 0; cnt<missionCheck; cnt++){
            stamp_list[`stamp${cnt+1}`].classList.add('p-sec2__stamp--done');
        }
    }
}

/* 탭별 테이블 구성 콜백 함수 */
let makeItemList = () => {
    let restoredDataList = dataAdapter.getRestoredData();
    let userData = dataAdapter.getAccountObj();
    let itemData = dataAdapter.getOriginItemList();
    let tab_class_name;

    // 이벤트 비정상 케이스 클래스 정의
    if(userData.banAccount || userData.gameBanAccount) tab_class_name = 'p-sec2__table--banned';
    if(userData.promotionTimeOver) tab_class_name = 'p-sec2__table--end';
    if(!userData.realName) tab_class_name = 'p-sec2__table--realname';

    // 카테고리 루프
    itemData.forEach((element,index) => {
        let elementString; //innerHtml을 위한 엘리먼트 문자열

        if(tab_class_name !== undefined){ // 이벤트 비정상 케이스
            elementString = `<div class="p-sec2__table ${tab_class_name}">`;
            if(!userData.realName)elementString += `<button type="button" class="p-btn p-btn__realname">실명인증</button>`;
            elementString += `</div>`;
        } else { // 이벤트 정상 케이스
            //복구할 아이템이 없을 경우.
            if(element.itemList.length === 0) return;
            //카테고리별 아이템 루프
            elementString = element['itemList'].reduce((pre,ele,idx) => {
                //테이블 구성.
                pre+=`
                        <tr>
                            <td>
                                <input type="radio" ${restoredDataList[index].state>0?'disabled':''} data-category="${element.itemDivisionId}" data-idx="${idx}" data-item="${ele.item_id}" name="itemTab${element.itemDivisionId}" id="itemTab${element.itemDivisionId}-${ele.item_id}-${idx}">
                                <label class="p-sec2__label" for="itemTab${element.itemDivisionId}-${ele.item_id}-${idx}"></label>
                            </td>
                            <td><img src="${NETWORKLINK[promokitStore.network].imgLink}${ele.imgUrl}">${ele.item_enchant>=0?'+'+ele.item_enchant:ele.item_enchant} ${ele.itemName}</td>    
                            <td>${ele.className || '-'}</td>
                            <td>${ele.item_attribute_name || '-'}</td>
                            <td>${ele.item_bless_name || '-'}</td>
                            <td>${ele.characterName || '-'}</td>
                            <td>${ele.failTime.substring(0,10)}</td>
                        </tr>
                    `;
                return pre;
            },`<table id="itemList_table${index}">`);
            elementString += '</table>';
        }
        document.querySelector(`#restore_${element.itemDivisionId}`).innerHTML = elementString;
    });
}

/* 탭 체인이 이벤트 콜백 함수 */
let tabChangeFunc = (index) => {
    let restoredData = dataAdapter.getRestoredData()[index];
    let selectedTable = document.querySelector(`#itemList_table${index}`);
    if(!restoredData) return;

    //테이블 클래스 초기화
    selectedTable && selectedTable.classList.remove('p-sec2__table-div--disabled');

    //서버 및 캐릭터 리스트 초기화
    module.init_select(server_select);
    module.init_select(char_select);

    //복구 신청하기 버튼 & 쿠폰 받기 변경
    module.buttonState(index);

    //현재 탭 정보 window 객체에 저장.
    window.selectedTab = index;

    if(selectedTable){
        //라디오 버튼 uncheck
        let checked_element = [...document.getElementsByName(`itemTab${index+1}`)].find((ele)=>ele.checked);
        checked_element && (checked_element.checked = false);

        //테이블 선택 하이라이트 초기화
        let highlight_element = [...selectedTable.rows].find((ele)=>ele.classList.contains('p-sec2__itemList--selected'));
        highlight_element && (highlight_element.classList.remove('p-sec2__itemList--selected'));
    }

    //카테고리 별 복구 정보에 따른 처리
    if(selectedTable && restoredData.state > 0) {
        if(restoredData.state == 1) module.makeRestoreValuesFunc(restoredData); // 선택한 정보값 레이어에 설정
        selectedTable.classList.add('p-sec2__table-div--disabled');
    }
}

/* 복구 신청 버튼 클릭 이벤트 콜백 함수 */
let restoreBtnFunc = (e) => {
    let selectedItem = dataAdapter.getItem();
    let missionCheck = dataAdapter.getMissionsCount();
    let restoreCount = dataAdapter.getRestoreCount();

    if(e.target.classList.contains('complete')){ // 복구 신청 완료인 경우
        layer_restored.open();
        return;
    }

    if(Object.keys(selectedItem).length == 0){ // 선택한 아이템이 없을 경우
        promokit.message({
            type: 'alert',
            message: '복구할 아이템을 선택해주세요.',
        });
        return;
    }

    if(char_select.value === null){ // 선택한 캐릭터가 없을 경우
        promokit.message({
            type: 'alert',
            message: '캐릭터를 선택해주세요.',
        });
        return;
    }

    //미션 횟수를 초과하여 복수 신청을 한 경우
    if(restoreCount >= missionCheck*2){
        promokit.message({
            type: 'alert',
            message: `${missionCheck*2}개를 초과하여 신청할 수 없습니다.`,
        });
        return;
    }

    module.makeRestoreValuesFunc(); // 선택한 정보값 레이어에 설정
    layer_restore.open();
};

/* 복구 신청 정보 값 설정 콜백함수 */
let makeRestoreValuesFunc = (restoredItem) => {
    //레이어 컨텐츠에 정보 값 설정
    if(restoredItem){//신청 내역 확인하기
        document.querySelector('#restored-item-name').textContent = restoredItem.itemName || '-';
        document.querySelector('#restored-item-attr').textContent = restoredItem.item_attribute_name || '-';
        document.querySelector('#restored-item-bless').textContent = restoredItem.item_bless_name || '-';
        document.querySelector('#restored-char-name').textContent = restoredItem.characterName || '-';
        document.querySelector('#restored-char-class').textContent = `${restoredItem.serverName || '-'} / ${restoredItem.className || '-'}`;
    }else{//복구 신청하기
        let selectedItem = dataAdapter.getItem();
        document.querySelector('#selected-item-name').textContent = selectedItem.itemName || '-';
        document.querySelector('#selected-item-attr').textContent = selectedItem.item_attribute_name || '-';
        document.querySelector('#selected-item-bless').textContent = selectedItem.item_bless_name || '-';
        document.querySelector('#selected-char-name').textContent = char_select.label || '-';
        document.querySelector('#selected-char-class').textContent = `${server_select.label || '-'} / ${char_select.value.class || '-'}`;
    }
}

/* 복구 신청 정보 값 전달 콜백함수 */
const sendRestoreInfo = () => {
    try {
        //신청 정보 값 만들어서 전달
        let dataObj = {};
        dataObj["serverId"] = server_select.value;
        dataObj["id"] = char_select.value.id;
        dataObj["item"] = dataAdapter.getItem();
        return dataObj;
    } catch (e) {
        console.log('선택된 신청 정보가 없습니다.');
    }
}
window.sendRestoreInfo = sendRestoreInfo; // 윈도우 객체에 설정.

/* 아인하사드 포인트 쿠폰 버튼 클릭 이벤트 콜백 함수 */
let rewardBtnFunc = (e) => {
    let missionCheck = dataAdapter.getMissionsCount();
    let restoreCount = dataAdapter.getRestoreCount();
    let userData = dataAdapter.getAccountObj();

    //실명인증
    if(!userData.realName) {
        promokit.message({
            type: 'alert',
            message: '본인확인이 필요합니다.',
            done:function(){
                window.location.href = NETWORKLINK[promokitStore.network].auth;
            }
        });
        return;
    }

    //제재 계정
    if(userData.banAccount || userData.gameBanAccount) {
        promokit.message({
            type: 'alert',
            message: '제재 계정은 이벤트에 참여할 수 없습니다.',
        });
        return;
    }

    //미션 횟수를 초과하여 복수 신청을 한 경우
    if(restoreCount >= missionCheck*2){
        promokit.message({
            type: 'alert',
            message: `${missionCheck*2}개를 초과하여 신청할 수 없습니다.`,
        });
        return;
    }
};

/* 로그인 버튼 콜백 함수 */
let loginBtnFunc = (e) => {
    if(e.target.classList.contains('p-btn__login')) promokit.login('#restore-itemList');
}


/* ---------------------------------------   모듈 선언부 --------------------------------------- */
/* 콜백 함수 사용 모듈(클로저) */
let module = (() => {
    return {
        /* 셀렉트 박스 초기화 콜백함수 */
        init_select : (selectBox) => {
            return init_select(selectBox);
        },
        /* 클릭 시 로그인 이벤트 리스너 등록 콜백 함수 */
        goLoginEvent : (element, url) => {
            return goLoginEvent(element, url);
        },
        /* 셀렉트 박스 변경 콜백 함수 */
        update_select : (selectBox, arr) => {
            return update_select(selectBox, arr);
        },
        /* 버튼 상태 변경 콜백 함수 */
        buttonState : (tab_index) => {
            return buttonState(tab_index);
        },
        /* 출석 체크 스탬프 콜백 함수 */
        checkStamp : () => {
            return checkStamp();
        },
        /* 탭별 테이블 구성 콜백 함수 */
        makeItemList : () => {
            return makeItemList();
        },
        /* 탭별 테이블 구성 콜백 함수 */
        tabChangeFunc : (index) => {
            return tabChangeFunc(index);
        },
        /* 복구 신청 정보 값 설정 콜백함수 */
        makeRestoreValuesFunc : (restoredData) => {
            return makeRestoreValuesFunc(restoredData);
        },
    }
})();

/* 데이터를 관리할 데이터 어댑터 모듈(클로저) */
let dataAdapter = (() => {
    let missionsCount = 0; //출석 미션 횟수 데이터.
    let restoreCount = 0; //복구 및 쿠폰 수령 횟수 데이터.
    let accountObj = {}; //계정 데이터.
    let originServerList = []; //서버와 캐릭터 원본 데이터.
    let originCharList = []; //캐릭터 원본 데이터.
    let originItemList = []; //아이템 원본 데이터.
    let selectItemObj = {}; //선택한 아이템.
    let restoredDataList = {}; //카테고리별 아이템 복구 정보.

    return {
        //서버에서 전달 받은 미션 횟수, 복구 및 쿠폰 수령 횟수 set.
        setMissionsCount : (num,arr) => {
            missionsCount = num;
            restoreCount = arr.reduce((pre,ele) => {
                return ele.restore.state > 0 ? pre+1:pre;
            },0);
        },
        //서버에서 전달 받은 미션 횟수 get.
        getMissionsCount : () => {
            return missionsCount;
        },
        //계산한 복구 및 쿠폰 수령 횟수 get.
        getRestoreCount : () => {
            return restoreCount;
        },
        //서버에서 전달 받은 계정 정보 얕은 복사로 set.
        setAccountObj : (obj) => {
            accountObj = obj;
        },
        //서버에서 전달 받은 계정 정보 get.
        getAccountObj : () => {
            return accountObj;
        },
        //서버에서 전달 받은 아이템리스트 얕은 복사로 set.
        setOriginItemList : (arr) => {
            originItemList = arr;
        },
        //서버에서 전달 받은 아이템리스트 get.
        getOriginItemList : () => {
            return originItemList;
        },
        //서버에서 전달 받은 서버 리스트와 캐릭터 리스트를 재가공하여 얕은 복사로 set.
        setOriginServerList : (arr) => {
            originServerList = arr;
            originCharList = arr.reduce((pre,ele) => {
                pre[ele.serverId] = ele.charList;
                return pre;
            },{});
        },
        //서버에서 전달 받은 서버 리스트 get.
        getOriginServerList : () => {
            return originServerList;
        },
        //서버에서 전달 받은 캐릭터 리스트 get.
        getOriginCharList : () => {
            return originCharList;
        },
        //현재 선택중인 아이템 set
        setItem : (obj) => {
            selectItemObj = obj;
        },
        //현재 선택중인 아이템 get
        getItem : () => {
            return selectItemObj;
        },
        //아이템 복구 정보 set.
        setRestoredData : (arr) => {
            restoredDataList = arr.reduce((pre,ele) => {
                pre.push({
                    state : ele.restore.state,
                    itemName : ele.restore.pickedItem && ele.restore.pickedItem.itemName,
                    item_attribute_name : ele.restore.pickedItem && ele.restore.pickedItem.item_attribute_name,
                    item_bless_name : ele.restore.pickedItem && ele.restore.pickedItem.item_bless_name,
                    characterName : ele.restore.pickedItem && ele.restore.pickedItem.characterName,
                    serverName : ele.restore.pickedItem && ele.restore.pickedItem.serverName,
                    className : ele.restore.pickedItem && ele.restore.pickedItem.className,
                });
                return pre;
            },[]);
        },
        //아이템 복구 정보 get.
        getRestoredData : () => {
            return restoredDataList;
        },
    };
})();

/* ajax 즉시실행함수(IIFE) */
(() => {
    $.ajax({
        url : '/events/lineage/2022/220209_signaturecoupon/getFailedItemList',
        type : 'GET',
        complete : (response) =>{
            if(response.status == 200){ //통신 성공
                try{
                    let jsonData = response.responseJSON;
                    if(jsonData){
                        /* 데이터 어댑터에 자료 저장 */
                        //계정 정보 저장.
                        dataAdapter.setAccountObj(jsonData.accountInfo);
                        //원본 서버와 캐릭터 데이터 저장.
                        dataAdapter.setOriginServerList(jsonData.serverByCharacter);
                        //원본 아이템 데이터 저장.
                        dataAdapter.setOriginItemList(jsonData.signatureTabInfoList);
                        //미션 정보와 복구 및 쿠폰 수령 정보 저장.
                        dataAdapter.setMissionsCount(jsonData.missionsCount, jsonData.signatureTabInfoList);
                        //카테고리별 아이템 복구 정보 저장
                        dataAdapter.setRestoredData(jsonData.signatureTabInfoList);

                        /* 콜백 함수 실행행 */
                        //아이템 리스트 테이블 설정.
                        module.makeItemList();
                        //최초 접속 시 보이는 첫 번째 탭 처리
                        if(dataAdapter.getRestoredData()[0].state == 1) module.makeRestoreValuesFunc(dataAdapter.getRestoredData()[0]); // 복구 정보 레이어에 설정
                        module.tabChangeFunc(0);
                        //출석 체크 미션
                        module.checkStamp();
                        //버튼 상태값 설정
                        module.buttonState(0);
                        //현재 탭 정보 window 객체에 저장.
                        window.selectedTab = 0;
                    }else{ //로그인하지 않았을 경우
                        //버튼에 로그인 기존 기능 제거 후 추가.
                        restoreBtn.removeEventListener('click',restoreBtnFunc);
                        rewardBtn.removeEventListener('click',rewardBtnFunc);
                        module.goLoginEvent(restoreBtn,'#selectBox');
                        module.goLoginEvent(rewardBtn,'#pointBox');
                    }
                }catch(err){
                }
            }
        }
    });
})();



/* --------------------------------------- 이벤트 선언부 --------------------------------------- */
/* 탭 이벤트 */
restore_tab.on('change', (index) => {
    module.tabChangeFunc(index.now);
});

/* 셀렉트박스 이벤트 */
server_select.on('change', () => {
    module.update_select(char_select,dataAdapter.getOriginCharList()[server_select.value]);
});

/* 아이템리스트 체크 박스 선택 이벤트 */
itemListElement.addEventListener('click',function(e){
    if(e.target.tagName !== 'INPUT') return; //체크박스 외 버블링 이벤트는 제외.

    //저장한 원본값을 호출하여 데이터어댑터에 선택한 아이템을 저장.
    let originItemList = dataAdapter.getOriginItemList()[e.target.dataset.category-1].itemList;
    dataAdapter.setItem(originItemList[e.target.dataset.idx]);

    //셀렉트 박스 업데이트
    module.update_select(server_select,dataAdapter.getOriginServerList());
    module.init_select(char_select); //캐릭터 셀릭트 박스 초기화.

    //선택한 라인 하이라이트
    [...document.querySelector(`#itemList_table${e.target.dataset.category-1}`).rows].forEach((element,index)=>{
        if(index == e.target.dataset.idx){
            element.classList.add('p-sec2__itemList--selected');
        }else{
            element.classList.remove('p-sec2__itemList--selected');
        }
    });
});

/* 로그인 버튼 클릭 이벤트 */
itemListElement.addEventListener('click',loginBtnFunc);
checkElement.addEventListener('click',loginBtnFunc);

/* 복구 신청하기 버튼 클릭 이벤트 */
restoreBtn.addEventListener('click',restoreBtnFunc);

/* 아인하사드 포인트 상자 쿠폰 버튼 클릭 이벤트 */
rewardBtn.addEventListener('click',rewardBtnFunc);

/* 실명확인 버튼 클릭 이벤트 */
itemListElement.addEventListener('click',function(e){
    if(e.target.classList.contains('p-btn__realname')){
        window.location.href = NETWORKLINK[promokitStore.network].auth;
    }
});
checkElement.addEventListener('click',function(e){
    if(e.target.classList.contains('p-btn__realname')){
        window.location.href = NETWORKLINK[promokitStore.network].auth;
    }
});



export {module, dataAdapter};
